export default "__VITE_ASSET__Ckjf0xIe__"